import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Promise } from 'es6-promise';
import { Query } from '../../global/functions/query';
import { FetchPendingAction } from '../../global/middleware/fetch-middleware';
import { getEpiProps } from '../../global/ducks/epi-api';
import { getLiturgicalEvents, LiturgicalCalendarState } from '../../global/ducks/liturgical-calendar-api';
import { IEpiProps } from '../models/epi-props';
import { IAppState } from '../index';
import * as moment from 'moment'
import { ILiturgicalEventDto } from '../../global/DTO/liturgical-calendar';
import { DropdownSelect, IDropdownOption } from '../../global/components/inputs/dropdown';
import { MathFunctions } from '../../global/functions/math';
import { DateSelection } from './date-selection';
import { EventList } from './event-list';

interface IStateProps {
    epiProps: IEpiProps,
    events: ILiturgicalEventDto[];
}

interface IDispatchProps {
    getEpiProps: () => FetchPendingAction;
    getEvents: (date: moment.Moment) => FetchPendingAction;
}

interface IOwnProps {
    contentId: string
    initialParams: { [key: string]: string[] }
    setQueryParams: (params: { [key: string]: string[] }) => void
}

type IProps = IStateProps & IDispatchProps & IOwnProps;

interface IState {
    currentDate: moment.Moment;
    queryParams: { [queryKey: string]: string[] };
}

export class LiturgicalCalendar extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        const currentDate = props.initialParams.currentDate && moment.default(props.initialParams.currentDate[0]) || moment.default().day(1);
        this.state = {
            currentDate,
            queryParams: {
                ...props.initialParams
            }
        }
    }

    static defaultProps = {
        epiProps: {},
        events: []
    }

    componentDidMount() {
        const {
            getEpiProps,
            getEvents
        } = this.props;

        Promise.all([
            getEpiProps().fetch,
            getEvents(this.state.currentDate).fetch
        ]).catch(err => console.warn(err)).then(this.onLoadingComplete)
    }

    onLoadingComplete = () => {
    }

    render() {
        const { epiProps } = this.props
        const { currentDate } = this.state;

        return (
            <div className="liturgical-calendar-view">
                <DateSelection
                    heading={epiProps.selectCalendarText}
                    buttonText={epiProps.showCalendarText}
                    onClick={this.getEvents}
                    startDate={currentDate}
                    />

                <EventList
                    events={this.getEventsInMonth(currentDate.month())} />

                <EventList
                    events={this.getEventsInMonth(currentDate.month() + 1)} />

                <EventList
                    events={this.getEventsInMonth(currentDate.month() + 2)} />
                    
            </div>)
    }

    getEvents = (value: moment.Moment) => {
        this.setState({ currentDate: value }, () => {
            this.onUpdateQuery();
            this.props.getEvents(this.state.currentDate).fetch.then(() => {
            }).catch(err => console.warn(err));
        });
    }

    onUpdateQuery = () => {
        const query = {
            ...this.state.queryParams
        }

        query.currentDate = [this.state.currentDate.format('YYYYMMDD')];

        this.props.setQueryParams(query);
    }

    getEventsInMonth = (month: number) => {
        const { currentDate } = this.state;

        return this.props.events.filter(x => {
            var filterDate = moment.default().day(1).month(month).year(currentDate.year());
            return x.eventDateTime.month() === filterDate.month()
        })
    }
}

const mapStateToProps = (state: IAppState): IStateProps => ({
    epiProps: state.epiState.props,
    events: state.liturgicalCalendar.events
})

const mapDispatchToProps = (dispatch, ownProps: IOwnProps): IDispatchProps => bindActionCreators({
    getEpiProps: () => getEpiProps(ownProps.contentId) as any,
    getEvents: getLiturgicalEvents as any,
}, dispatch)


export const LiturgicalCalendarApp = connect<IStateProps, IDispatchProps, IOwnProps>(mapStateToProps, mapDispatchToProps)(LiturgicalCalendar as any);